import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import classNames from "classnames";
import FAIcon from "../FAIcon/FAIcon";
import useUniqueId from "../../Hooks/useUniqueId";
import A11yHelpers from "../../../../util/A11yHelpers";
import useDropdown from "../../Hooks/useDropdown";
import DateService from "../../../Services/Shared/Date.service";
const date = moment();
date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
const times = [moment(date).toDate()];
const hourInterval = 0.25;
for (let i = 1; i < (1 / hourInterval) * 24; i++) {
    date.add(Math.round(60 * hourInterval), "m");
    times.push(moment(date).toDate());
}
const formatDate = (d, locale = "en-US") => {
    const options = {
        hour: "numeric",
        minute: "2-digit",
    };
    return d && new Intl.DateTimeFormat(locale, options).format(d);
};
export const hours24MinutesToDate = (hours24, minutes) => {
    const d = new Date();
    d.setHours(hours24);
    d.setMinutes(minutes);
    return d;
};
export const dateToHours24Minutes = (d) => ({
    hours24: DateService.getHours24(d),
    minutes: DateService.getMinutes(d),
});
const TimePicker = (props) => {
    const [val, setVal] = React.useState("");
    React.useEffect(() => {
        if (props.value) {
            setVal(formatDate(props.value));
        }
    }, [props.value]);
    const makeId = useUniqueId()[1];
    const buttonRef = React.useRef(null);
    const [isDropdownOpen] = useDropdown(buttonRef);
    return (_jsxs("div", { className: "input-group", style: { maxWidth: 140 }, role: "combobox", "aria-haspopup": "true", "aria-expanded": isDropdownOpen, "aria-controls": makeId("dropdownMenuButton"), children: [_jsx("input", { type: "text", className: classNames("form-control", {
                    "is-invalid": props.isValid === false,
                }), value: val, autoComplete: "off", placeholder: "Time", onChange: (e) => {
                    const newVal = e.target.value;
                    setVal(newVal);
                    const newDate = moment(newVal, "h:mm a", true);
                    if (newDate.isValid()) {
                        props.onChange(newDate.toDate());
                    }
                    else {
                        props.onChange(null);
                    }
                }, disabled: props.disabled }), _jsxs("div", { className: "input-group-append input-group-append-blend", children: [_jsx("button", { ref: buttonRef, "data-toggle": "dropdown", className: props.disabled ? "btn btn-dark" : "btn btn-outline-secondary", type: "button", id: makeId("dropdownMenuButton"), title: "Open dropdown", disabled: props.disabled, children: _jsx(FAIcon, { icon: "chevron-down" }) }), _jsx("div", { className: "dropdown-menu dropdown-menu-right shadow", role: "listbox", id: makeId("timeDropdownListBox"), "aria-labelledby": makeId("dropdownMenuButton"), style: { maxHeight: 150, height: "auto", overflowX: "hidden" }, children: times.map((time, i) => (_createElement("div", Object.assign({ tabIndex: 0, role: "option", "aria-selected": !!props.value && formatDate(props.value) === formatDate(time), className: classNames("dropdown-item clickable", {
                                active: props.value && formatDate(props.value) === formatDate(time),
                            }) }, A11yHelpers.onClickOrEnterOrSpace(() => {
                            setVal(formatDate(time));
                            props.onChange(time);
                        }), { key: i }), formatDate(time)))) })] }), _jsx("div", { className: "invalid-feedback", children: props.invalidFeedback })] }));
};
export default TimePicker;
